import { request } from "@/utils/request";

export async function getZones() {
  // 文档：GET /shopify-app/zones
  return request<any>(`/shopify-app/zones`, {
    method: "GET",
  });
}

export async function getCountries() {
  // 文档：GET /shopify-app/zones/countries
  return request<any>(`/shopify-app/zones/countries`, {
    method: "GET",
  });
}

export async function createZone(data: any) {
  // 文档：POST /shopify-app/zones
  return request<any>(`/shopify-app/zones`, {
    method: "POST",
    data,
  });
}

export async function updateZone(data: any) {
  // 文档：PUT /shopify-app/zones/{zoneId}
  return request<any>(`/shopify-app/zones/${data.zone.id}`, {
    method: "PUT",
    data,
  });
}

export async function deleteZone(id: number) {
  // 文档：DELETE /shopify-app/zones/{id}
  return request<any>(`/shopify-app/zones/${id}`, {
    method: "DELETE",
  });
}
